var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTagActivo = function SvgTagActivo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "tag_activo_svg__Capa_2",
    viewBox: "0 0 16 10.06"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tag_activo_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 10.06,
    x: 0,
    y: 0,
    rx: 5.03,
    ry: 5.03,
    fill: "#2ad2c5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.86,
    cy: 5.03,
    r: 4.34,
    fill: "#fff"
  }))));
};
export default SvgTagActivo;